module.exports = __webpack_public_path__ + "img/cargoService.b4fbdab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cargoService.jpg
// module id = fXX0
// module chunks = 2